import type { HealthResponse } from './types';

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

export async function getHealth(): Promise<HealthResponse> {
  const res = await fetch(`${BASE_URL}/health`);
  if (!res.ok) throw new Error(`Health check failed: ${res.status}`);
  return res.json() as Promise<HealthResponse>;
}
